/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const UserStatus = {
    Active: 'Active',
    Banned: 'Banned',
    Suspended: 'Suspended',
    Verifying: 'Verifying',
    Deleted: 'Deleted',
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];



